import { setSystemUsers } from "../../Redux/slices/staffSlice";
import { setAppointmentTypes, setDaysLimitsData, setFirstData } from "../../Redux/slices/globalSlice";
import { setUserAccess, setUserData } from "../../Redux/slices/userSlice";
import { HandleLoading } from "./HandleLoading";
import { removeLocalStorage } from "./Token";
import { setSystemPatients } from "../../Redux/slices/patientSlice";
import { setAppointments, setPatientAppointments } from "../../Redux/slices/appointmentSlice";
import { ConvertToAccess } from "./AccessConvert";
import { read } from "./LocalStorage";

export const SetUserData = (data, navigate) => {
    return async (dispatch) => {
        try {
            const access = ConvertToAccess(read('access'), false);
            if(access) {
                await dispatch(setUserData(data));
                await dispatch(setSystemUsers(data));
                await dispatch(setFirstData(data));
                await dispatch(setUserAccess(access));
            } else {
                removeLocalStorage();
                window.location.replace("/");
            }
            dispatch(HandleLoading(false));
        } catch (e) {}
    }
}

export const SetPatientData = (data) => {
    return async (dispatch) => {
        try {
            await dispatch(setSystemPatients(data));
            dispatch(HandleLoading(false));
        } catch (e) {}
    }
}

export const SetUsersData = (data) => {
    return async (dispatch) => {
        try {
            await dispatch(setSystemUsers({users: data}));
            dispatch(HandleLoading(false));
        } catch (e) {}
    }
}

export const SetDaysLimits = (data) => {
    return async (dispatch) => {
        try {
            await dispatch(setDaysLimitsData(data));
            dispatch(HandleLoading(false));
        } catch (e) {}
    }
}

export const SetSystemTypes = (data) => {
    return async (dispatch) => {
        try {
            await dispatch(setAppointmentTypes(data));
            dispatch(HandleLoading(false));
        } catch (e) {}
    }
}

export const SetAppointmentsData = (data) => {
    return async (dispatch) => {
        try {
            await dispatch(setAppointments(data));
            dispatch(HandleLoading(false));
        } catch (e) {}
    }
}

export const SetPatientAppointmentsData = (data) => {
    return async (dispatch) => {
        try {
            if(data) {
                await dispatch(setPatientAppointments(data.data));
            } else {
                await dispatch(setPatientAppointments(null));
            }
            dispatch(HandleLoading(false));
        } catch (e) {}
    }
}

export const HandleVibrate = () => {
    try { navigator.vibrate(6); } catch (e) {}
}